export var MAP_NAME = {
    us: 'USA',
    world: 'world',
};
